import { Github, Linkedin, Mail, ArrowUp } from 'lucide-react';

interface FooterProps { linkedIn: string; github: string; mail: string; }

const iconLink = 'w-11 h-11 rounded-full flex items-center justify-center text-zinc-500 hover:text-ink transition-colors';

export default function Footer({ linkedIn, github, mail }: FooterProps) {
  return (
    <footer className="border-t border-line">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between gap-4">
        <p className="text-zinc-500 text-sm">&copy; {new Date().getFullYear()} Nathan Victorin</p>
        <div className="flex items-center">
          {linkedIn && <a href={linkedIn} target="_blank" rel="noopener noreferrer" className={iconLink} aria-label="LinkedIn"><Linkedin size={16} /></a>}
          {github && <a href={github} target="_blank" rel="noopener noreferrer" className={iconLink} aria-label="GitHub"><Github size={16} /></a>}
          {mail && <a href={`mailto:${mail}`} className={iconLink} aria-label="Email"><Mail size={16} /></a>}
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className={iconLink} aria-label="Back to top">
            <ArrowUp size={16} />
          </button>
        </div>
      </div>
    </footer>
  );
}
